"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Helpers_exports = {};
__export(Helpers_exports, {
  computedId: () => computedId,
  getFocusableEls: () => getFocusableEls,
  hasDocument: () => hasDocument,
  hasWindow: () => hasWindow,
  matchMedia: () => matchMedia,
  mergeRefs: () => mergeRefs,
  trapFocus: () => trapFocus
});
module.exports = __toCommonJS(Helpers_exports);
var import_baseTheme = __toESM(require("../themes/baseTheme"));
function getFocusableEls(element) {
  if (!element) {
    return [];
  }
  var focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), \n    input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), \n    select:not([disabled]), [tabindex]:not([disabled])');
  return focusableEls;
}
function trapFocus(element) {
  var focusableEls = getFocusableEls(element);
  var firstFocusableEl = focusableEls[0];
  var lastFocusableEl = focusableEls[focusableEls.length - 1];
  var KEYCODE_TAB = 9;
  element.addEventListener("keydown", function(e) {
    var isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
      return;
    }
    if (e.shiftKey) {
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else if (document.activeElement === lastFocusableEl) {
      firstFocusableEl.focus();
      e.preventDefault();
    }
  });
}
var computedId = function computedId2(nodeName, id) {
  return "select-".concat(nodeName).concat(id ? "-".concat(id) : "");
};
var hasWindow = function hasWindow2() {
  return typeof window !== "undefined";
};
var hasDocument = function hasDocument2() {
  return typeof document !== "undefined";
};
var matchMedia = function matchMedia2() {
  var small = hasWindow() && window.matchMedia("(min-width: ".concat(import_baseTheme.default.breakpoints.sm, ")"));
  var medium = hasWindow() && window.matchMedia("(min-width: ".concat(import_baseTheme.default.breakpoints.md, ")"));
  var desktop = hasWindow() && window.matchMedia("(min-width: ".concat(import_baseTheme.default.breakpoints.lg, ")"));
  return {
    small,
    medium,
    desktop
  };
};
var mergeRefs = function mergeRefs2(refs) {
  return function(value) {
    refs.forEach(function(ref) {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null) {
        var refEl = ref;
        refEl.current = value;
      }
    });
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  computedId,
  getFocusableEls,
  hasDocument,
  hasWindow,
  matchMedia,
  mergeRefs,
  trapFocus
});
//# sourceMappingURL=Helpers.js.map